/**
 * Admin calorie simulation endpoint — used by the kcal simulator in
 * the admin → Modelo veterinario panel.
 *
 * Extracted from `src/services/api.ts` (Fase 10 Slice 10.9).
 *   - POST /admin/simulations/calories — DER for a synthetic dog profile
 *
 * Re-exported from services/api.ts so existing call-sites keep working.
 */

import { apiClient } from '../client';

export interface CalorieSimulationRequest {
  age_months: number;
  current_weight_kg: number;
  activity_level: 'low' | 'medium' | 'high';
  weight_status: 'underweight' | 'ideal' | 'overweight';
  breed_name?: string;
  breed_code?: string;
}

export interface CalorieSimulationResponse {
  kcal_day: number;
  life_stage: 'puppy' | 'adult' | 'transition';
  estimated_adult_weight_kg: number;
  size_class: 'xs' | 's' | 'm' | 'l' | 'xl';
  factors: {
    // Claves del K-model (backend K-model).
    k_age?: number;
    k_bcs?: number;
    k_activity?: number;
    k_total?: number;
    neutered_factor_applied?: number;
    // Claves legacy derivadas del K-model:
    // activity_factor = k_activity x 100, body_status_delta = (k_bcs - 1) x 100.
    activity_factor: number;
    body_status_delta: number;
    senior_factor: number;
  };
  diagnostics: string[];
}

export const adminSimulateCalories = async (payload: CalorieSimulationRequest): Promise<CalorieSimulationResponse> => {
  const response = await apiClient.post<CalorieSimulationResponse>('/admin/simulations/calories', payload, {});
  return response.data;
};
